<template>
  <div class="contents_wrapper">
    <Header :title="'施設予約'" />
    <div class="contents">
      <div class="result_main">
        <div class="result_text">予約する施設を選択してください</div>
        <ul class="result_list">
          <template v-for="(room, i) in rooms">
            <li v-bind:key="room.address" v-if="room.isNotBusy" class="result_list_item">
              <a href="javascript:void(0)" @click="selected(room, i)" class="result_list_item_a">
                <div class="list_item_icon">
                  <img :src="$designResource.resultDoor" alt />
                </div>
                <div class="list_item_text">{{room.name}}</div>
              </a>
            </li>
          </template>
        </ul>
      </div>
      <ButtonGroup></ButtonGroup>
    </div>
  </div>
</template>

<script>
import Header from "../components/Header.vue";
import ButtonGroup from "../components/ButtonGroup.vue";

import loggerService from "../services/loggerService";
import Store from "../store";

import moment from "moment";

const store = new Store();

export default {
  components: {
    Header,
    ButtonGroup
  },
  data: function() {
    return {
      now: new Date(),
      selectedTime: null,
      rooms: [],
    };
  },
  created: function() {
    loggerService.pageView("SearchResult");
    this.selectedTime = moment(Number(this.$route.query["targetTime"]));
    this.rooms = store.searchResult;
  },
  methods: {
    selected: function(room) {
      this.$router.push({
        path: `/booking/${room.id}`,
        query: {
          roomFrom: this.$route.query["roomFrom"],
          bookon: this.$route.query["targetTime"]
        }
      });
    }
  }
};
</script>

<style lang="scss">
@charset "utf-8";
.result_main {
  width: 100%;
  height: calc(100% - 130px);
  box-sizing: border-box;
}
.result_text {
  color: $txtColor;
  font-size: 18px;
  width: 100%;
  text-align: center;
  padding: 20px 0;
  box-sizing: border-box;
}
.result_list {
  width: 100%;
  padding: 0 10%;
  box-sizing: border-box;
  margin-top: 40px;
  overflow-y: auto;
  height: calc(100% - 140px);
}
.result_list_item {
  width: 100%;
  border-radius: 5px;
  margin-bottom: 14px;
  background-color: #fff;
  box-shadow: 1px 1px 5px 0px rgba(97, 79, 67, 0.3);
}
.result_list_item_a {
  width: 100%;
  border-radius: 5px;
  display: flex;
  align-items: center;
  padding: 20px 0;
  box-sizing: border-box;
  color: #000000;
}
.list_item_icon {
  width: 70px;
  text-align: center;
}
.list_item_icon > img {
  width: 16px;
}
.list_item_text {
  width: calc(100% - 70px);
  padding-right: 20px;
  box-sizing: border-box;
}
/** 反転 - リスト **/
.result_list_item.active {
  background-color: $txtColor;
}
.result_list_item.active .result_list_item_a {
  color: #fff;
}
.search_msg-active {
  text-align: center;
}
</style>